import Joi from "joi-browser";

const ScannerSettingsSchema = Joi.object().keys({
    interpolation: Joi.string().trim().required(),
    apodization: Joi.string().trim().required(),
    FFTPoints: Joi.string().trim().required(),
    gain: Joi.string().trim().required(),
    scanTime: Joi.number().positive().required(),
});

export default { ScannerSettingsSchema };
